/* eslint-disable no-continue */
import { alignLogToVideo, resolveVideoAtSeconds } from './incidentLog';
import { withDefaultVideoMedia } from '../mockData';

export function sortByDisplayOrder(items = []) {
  return items.slice().sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
}

export function firstNonEmpty(...values) {
  for (let i = 0; i < values.length; i += 1) {
    const value = values[i];
    if (value == null) continue;
    const text = String(value).trim();
    if (text) return text;
  }
  return '';
}

export function formatConclusionText(text) {
  return String(text || '')
    .replace(/\r\n/g, '\n')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
}

/**
 * Media / incident log from scenario; questions + timing from submission detail (API source of truth).
 * Live API: use videoUrl / videoHtml / youtubeVideoId as returned (empty → player placeholder).
 * Mock: may fill a local/env default clip when media is missing.
 */
export function mergeWalkthroughVideos(scenarioVideos = [], submissionVideos = [], { useMockDefaults = false } = {}) {
  const submissionById = new Map((submissionVideos || []).map((video) => [Number(video.videoId), video]));
  const scenarioList = sortByDisplayOrder(scenarioVideos || []);

  function withAlignedLog(video) {
    const startSeconds = Number(video?.startSeconds) || 0;
    const explicitPause = resolveVideoAtSeconds((video?.incidentLog || []).find((entry) => entry.isCurrent));
    const { incidentLog, pauseAtSeconds } = alignLogToVideo(video?.incidentLog || [], {
      startSeconds,
      pauseAtSeconds:
        Number.isFinite(Number(video?.pauseAtSeconds)) && Number(video.pauseAtSeconds) > startSeconds
          ? Number(video.pauseAtSeconds)
          : explicitPause != null
            ? explicitPause
            : undefined,
    });
    const next = {
      ...video,
      incidentLog,
      pauseAtSeconds: pauseAtSeconds ?? video?.pauseAtSeconds,
    };
    return useMockDefaults ? withDefaultVideoMedia(next) : next;
  }

  if (scenarioList.length) {
    return scenarioList.map((video, index) => {
      const fromSubmission = submissionById.get(Number(video.videoId)) || submissionVideos[index];
      return withAlignedLog({
        ...video,
        heading: fromSubmission?.heading || video.heading,
        videoTiming: fromSubmission?.videoTiming ?? video.videoTiming ?? null,
        // Prefer scenario package media; fall back to submission if the list omitted URLs.
        videoUrl: firstNonEmpty(video.videoUrl, fromSubmission?.videoUrl),
        videoHtml: firstNonEmpty(video.videoHtml, fromSubmission?.videoHtml),
        youtubeVideoId: firstNonEmpty(video.youtubeVideoId, fromSubmission?.youtubeVideoId) || null,
        thumbnail: firstNonEmpty(video.thumbnail, fromSubmission?.thumbnail) || null,
        questions:
          Array.isArray(fromSubmission?.questions) && fromSubmission.questions.length
            ? fromSubmission.questions
            : video.questions || [],
      });
    });
  }

  return (submissionVideos || []).map((video) =>
    withAlignedLog({
      ...video,
      videoUrl: firstNonEmpty(video.videoUrl),
      videoHtml: firstNonEmpty(video.videoHtml),
      youtubeVideoId: firstNonEmpty(video.youtubeVideoId) || null,
      thumbnail: firstNonEmpty(video.thumbnail) || null,
      incidentLog: video.incidentLog || [],
      questions: video.questions || [],
    }),
  );
}
